import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoFeedbackModule } from '@xpo-ltl/ngx-ltl-core/feedback';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoBrowserGuardModule } from '@xpo-ltl/ngx-ltl-core/browser-guard';
import { XpoPageNotFoundRoutingModule } from '@xpo-ltl/ngx-ltl-core/error-page';

import { UserApiService } from '@xpo-ltl/sdk-user';
import { InvoiceApiService } from '@xpo-ltl/sdk-invoice';
import { CustomerApiService } from '@xpo-ltl/sdk-customer';
import { ShipmentApiService } from '@xpo-ltl/sdk-shipment';
import { ShipmentOdsApiService } from '@xpo-ltl/sdk-shipmentods';
import { DataApiService, NotificationService } from '@xpo-ltl/data-api';
import { OrderManagementApiService } from '@xpo-ltl/sdk-ordermanagement';
import { AccountsReceivableApiService } from '@xpo-ltl-2.0/sdk-accountsreceivable';
import { ConditioningService, FormatValidationService } from '@xpo-ltl/common-services';
import {
  ConfigManagerModule,
  ConfigManagerService,
  CONFIG_MANAGER_SERVICE_CONFIGURATION,
} from '@xpo-ltl/config-manager';

import { ClipboardModule, ClipboardService } from 'ngx-clipboard';

import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { XpoAuthConfig, XPO_AUTH_CONFIG } from '@xpo/ngx-auth';
import { XpoLtlAuthConfigLoaderService, XpoLtlAuthenticationService, XpoLtlAuthModule } from '@xpo-ltl/ngx-auth';
import { environment } from 'environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { InvoiceAuditorService } from '@shared/services/invoice-auditor/invoice-auditor.service';
import { DocumentManagementV2ApiService } from '@xpo-ltl-2.0/sdk-documentmanagementv2';
import { AngularFireModule } from '@angular/fire/compat';
import { LoginService } from '@xpo-ltl/login';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';

export function authConfigFactory(
  configService: XpoLtlAuthConfigLoaderService
): XpoAuthConfig {
  configService.initSettings('./assets/config.json');
  configService.apiUrl = configService.apiUrl.replace(/\/+$/, '');

  return new XpoAuthConfig({
    appCode: configService.appCode,
    scopes: configService.scopes,
    isProd: configService.isProd,
    applicationRootUri: configService.appRootUri,
  });
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    // Angular
    BrowserModule,
    BrowserAnimationsModule,

    // XPO
    XpoShellModule,
    XpoDialogModule,
    XpoSnackBarModule,
    XpoFeedbackModule,
    ConfigManagerModule,
    XpoBrowserGuardModule,

    // local
    CoreModule,
    SharedModule,

    // others
    ClipboardModule,
    HttpClientModule,

    // Auth
    XpoLtlAuthModule.forRoot({
      provide: XPO_AUTH_CONFIG,
      useFactory: authConfigFactory,
      deps: [XpoLtlAuthConfigLoaderService, InvoiceAuditorService],
    }),
    AppRoutingModule, // Keep last
    XpoPageNotFoundRoutingModule, // Keep laster
  ],
  providers: [
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json' } },
    DatePipe,
    DecimalPipe,
    CurrencyPipe,
    DataApiService,
    UserApiService,
    ClipboardService,
    InvoiceApiService,
    ShipmentApiService,
    CustomerApiService,
    DocumentManagementV2ApiService,
    NotificationService,
    ConditioningService,
    ConfigManagerService,
    ShipmentOdsApiService,
    FormatValidationService,
    OrderManagementApiService,
    XpoLtlAuthenticationService,
    AccountsReceivableApiService,
    LoginService,
    MatLegacyDialogRef
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
